export type Audesp4ObraRodoviariaSaneamentoSim = {
    HouveLevantamentoCondicoesFisicasAreasSelecionadas: 'S' | 'N';
    AreasSelecionadasAdotadosCriteriosTecnicosArt6IXLei866693: 'S' | 'N';
}